import { render, staticRenderFns } from "./editFeeConfig.vue?vue&type=template&id=3f160f57&scoped=true"
import script from "./editFeeConfig.vue?vue&type=script&lang=js"
export * from "./editFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./editFeeConfig.vue?vue&type=style&index=0&id=3f160f57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f160f57",
  null
  
)

export default component.exports